mutation CreateRefund($input: CreateRefundInput!) {
  createRefund(input: $input) {
    id
    status
    manual
    amount {
      value
      currency
    }
    # Платёж с новым статусом и списком возвратов: Apollo обновляет запись
    # Payment:<id> в кеше, и список платежей с открытой карточкой
    # перерисовываются сразу, не дожидаясь refetch.
    payment {
      id
      status
      refunds {
        id
        status
        manual
        createdAt
        amount {
          value
          currency
        }
      }
    }
  }
}
